import diversifiedtransport from '../../components/diversifiedTransport/diversifiedTransport'
import diversifiedtransport2 from '../../components/diversifiedTransport2/diversifiedTransport2'
import diversifiedtransport3 from '../../components/diversifiedTransport3/diversifiedTransport3'
import diversifiedtransportIndex from '../../components/diversifiedtransportIndex/diversifiedtransportIndex'
import valueAdded from '../../components/valueAdded/valueAdded'
import warehousingIndex from '../../components/warehousingIndex/warehousingIndex'
import warehousing1 from '../../components/warehousing1/warehousing1'
import warehousing from '../../components/warehousing/warehousing'
import warehousing2 from '../../components/warehousing2/warehousing2'
import internationalFreight from '../../components/internationalFreight/internationalFreight'
import supplyChain from '../../components/supplyChain/supplyChain'
import integrationTransportation from '../../components/integrationTransportation/integrationTransportation'
export default {
    components: {
        diversifiedtransportIndex: diversifiedtransportIndex,
        diversifiedtransport: diversifiedtransport,
        diversifiedtransport2: diversifiedtransport2,
        diversifiedtransport3: diversifiedtransport3,
        valueAdded: valueAdded,
        warehousing1: warehousing1,
        warehousing: warehousing,
        warehousing2: warehousing2,
        warehousingIndex: warehousingIndex,
        internationalFreight: internationalFreight,
        supplyChain: supplyChain,
        integrationTransportation: integrationTransportation
    },
    created() {
      var route = this.$route.path
      if(route === '/services/warehousing') {
        // this.currentMenu = '1-1'
        this.currentMenu = "/services/warehousing"
      } else if (route === '/services/diversifiedTransport') {
        // this.currentMenu = '2-1'
        this.currentMenu = "/services/diversifiedTransport"
      } else if (route === '/services/internationalFreight') {
        this.currentMenu = '/services/internationalFreight'
      } else if (route === '/services/valueAdded') {
        this.currentMenu = '/services/valueAdded'
      } else if (route === '/services/supplyChain') {
        // this.currentMenu = '5-1'
        this.currentMenu = '/services/supplyChain'
      }
    },
    data() {
      return {
        // 滚动条高点
        scrollTopTemp : 0,
        //当前选中菜单
        currentMenu: '',
      };
    },
    watch:{
      //监听路由变化
      $route(to,from){
          console.log(to.path)//到哪去
          var route = to.path
          var index = this.$route.query.index || ''
          if(route === '/services/warehousing') {
            if(index){
              this.currentMenu = index
            }else{
              this.currentMenu = '/services/warehousing'
            }
          } else if (route === '/services/diversifiedTransport') {
            if(index){
              this.currentMenu = index
            }else{
              this.currentMenu = '/services/diversifiedTransport'
            }
          } else if (route === '/services/internationalFreight') {
            this.currentMenu = '/services/internationalFreight'
          } else if (route === '/services/valueAdded') {
            this.currentMenu = '/services/valueAdded'
          } else if (route === '/services/supplyChain') {
            if(index){
              this.currentMenu = index
            }else{
              this.currentMenu = '/services/supplyChain'
            }
          }
      }
    },
    methods: {
      selectFatherMenu(value) {
        var route = this.$route.path
        if(value == '/services/warehousing' &&  value !== route){
          this.$router.push(value)
        } else if(value == '/services/supplyChain' &&  value !== route){
          this.$router.push(value)
        } else if(value == '/services/diversifiedTransport' &&  value !== route){
          this.$router.push(value)
        } else {
          this.currentMenu = value
        }
      },
      selectMenu(page){
        var route = this.$route.path
        this.currentMenu = page
        if(page.slice(0,1) == '1' && route != '/services/warehousing') {
          this.$router.push({path:'/services/warehousing',query: { index: this.currentMenu}})
        } else if (page.slice(0,1) == '2' && route != '/services/diversifiedTransport') {
          this.$router.push({path:'/services/diversifiedTransport',query:{index: this.currentMenu}})
        } else if (page == '/services/internationalFreight' && route != '/services/internationalFreight') {
          this.$router.push('/services/internationalFreight')
        } else if (page == '/services/valueAdded' && route != '/services/valueAdded') {
          this.$router.push('/services/valueAdded')
        } else if (page.slice(0,1) == '5' && route != '/services/supplyChain') {
          this.$router.push({path:'/services/supplyChain',query: { index: this.currentMenu}})
        }
      },
      goToDetail(path){
        this.currentMenu = path
      }
    }

}


// WEBPACK FOOTER //
// ./src/pages/services/services.vue.js